'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/fca.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _grid = require('@marmalade/grid');
var _constants = require('@marmalade/constants');
var _constants2 = _interopRequireDefault(_constants);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var FCA = _constants2.default.FCA;
FcaFooter.propTypes = {
  theme: _propTypes.object.isRequired
};
function FcaFooter(_ref) {
  var theme = _ref.theme;
  return _react2.default.createElement(_glamorous2.default.Footer, {
    css: {
      backgroundColor: theme.colorBlack,
      color: theme.colorWhite,
      padding: theme.space_md + ' 0',
      fontSize: '14px'
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15
    },
    __self: this
  }, _react2.default.createElement(_grid.Container, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23
    },
    __self: this
  }, _react2.default.createElement(_glamorous2.default.Div, {
    id: 'update-cookie-preferences-container',
    css: {
      marginBottom: '14px'
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24
    },
    __self: this
  }), _react2.default.createElement('div', {
    dangerouslySetInnerHTML: {
      __html: FCA
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25
    },
    __self: this
  })));
}
exports.default = (0, _glamorous.withTheme)(FcaFooter);